//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { Opaque } from '@utils/opaque';

type NetworkUserId = Opaque<string, 'NetworkUserId'>;

function NetworkUserIdFactory(networkUserId: string) {
  return networkUserId as NetworkUserId;
}

const NetworkUserId = Object.assign(NetworkUserIdFactory, {});

export default NetworkUserId;
